import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseData } from '../interfaces/response.interface';
import { ModifyDepositLimit, SetTimeoutResponse, TimeoutReopenResponse } from '../interfaces/responsible.interface';
import { BaseApi } from './base.api';
@Injectable({
  providedIn: 'root',
})
export class ResponsibleApi extends BaseApi {
  /**
   * 用户存款限额
   *
   * @returns //
   */
  getDepositLimit(): Observable<ModifyDepositLimit | null> {
    const url = `${environment.apiUrl}/v1/member/selfrestraint/getdepositlimit`;
    return this.get<ResponseData<ModifyDepositLimit>>(url).pipe(map(x => x?.data || null));
  }

  /**
   * 更新用户存款限额
   *
   * @param dailyLimit
   * @param weeklyLimit
   * @param monthlyLimit
   * @param currency
   * @returns //
   */
  postModifyDepositLimit(
    dailyLimit: number | null,
    weeklyLimit: number | null,
    monthlyLimit: number | null,
    currency?: string,
  ): Observable<ResponseData<ModifyDepositLimit>> {
    const url = `${environment.apiUrl}/v1/member/selfrestraint/modifydepositlimit`;
    return this.post<ResponseData<ModifyDepositLimit>>(url, {
      dailyLimit,
      weeklyLimit,
      monthlyLimit,
      ...(currency ? { currency } : {}),
    });
  }

  /**
   * 删除用户存款限额预设
   *
   * @param cancelType
   * @returns //Daily, Weekly, Monthly
   */
  cancelDepositLimitPreset(cancelType: string): Observable<ModifyDepositLimit | null> {
    const url = `${environment.apiUrl}/v1/member/selfrestraint/canceldepositlimitpreset`;
    return this.post<ResponseData<ModifyDepositLimit>>(url, {
      cancelType,
    }).pipe(map(v => v?.data || null));
  }

  checkdepositlimit() {
    const url = `${environment.apiUrl}/v1/member/selfrestraint/checkdepositlimit`;
    return this.get(url);
  }

  /**
   * 用户自我排除设定
   *
   * @param exclusionUntil
   * @returns  "exclusionUntil": "2024-05-07T02:18:49.227Z"
   */
  setSelFexClusion(exclusionUntil: string): Observable<boolean> {
    const url = `${environment.apiUrl}/v1/member/selfrestraint/setselfexclusion`;
    return this.post<ResponseData<boolean>>(url, {
      exclusionUntil,
    }).pipe(map(v => v?.data || false));
  }

  /**
   * 设置用户 timeout
   *
   * @param period - timeout 时长（秒）
   * @param startUnixTimestamp - 开始时间的 Unix 时间戳（毫秒）
   * @returns
   */
  setTimeout(period: number, startUnixTimestamp: number): Observable<ResponseData<SetTimeoutResponse>> {
    const url = `${environment.apiUrl}/v1/member/selfrestraint/settimeout`;
    return this.post<ResponseData<SetTimeoutResponse>>(url, {
      period,
      startUnixTimestamp,
    });
  }

  /**
   * 检查用户 timeout 状态
   *
   * @returns { status: 'Active' | 'None', until: number }
   */
  checkTimeout(): Observable<{ status: string; until: number } | null> {
    const url = `${environment.apiUrl}/v1/member/selfrestraint/checktimeout`;
    return this.get<ResponseData<{ status: string; until: number }>>(url).pipe(map(v => v?.data || null));
  }

  /**
   * 请求提前重开账户（进入 cooling-off period）
   *
   * @param reopenKey - 重新开放密钥
   * @returns TimeoutReopenResponse
   */
  requestEarlyReopen(reopenKey: string): Observable<ResponseData<TimeoutReopenResponse>> {
    const url = `${environment.apiUrl}/v1/member/selfrestraint/timeoutreopen`;
    return this.post<ResponseData<TimeoutReopenResponse>>(url, { reopenKey });
  }
}
